module.exports = __webpack_public_path__ + "static/media/new_shortcut_image.3f9b5882.png";